<div class="cell-due-date"
     *ngIf="dueDate | dueDateString as dueDateString"
     [ngStyle]="{ background: showBackground ? dueDateString?.color : '' }"
     (click)="canEdit && dp.show()"
     stopEvent
     [ngClass]="{'background-view' : showBackground }"
     [title]="dueDateString.dueDateDescription">
  <mat-icon *ngIf="showIcon" class="icon-clock mr-2" [svgIcon]="'clock'"></mat-icon>

  <span class="d-block pointer text-center text-due-date"
        [ngClass]="{'fw-5': dueDate}"
        [innerHTML]="showBackground ? dueDateString.text : dueDateString.dueDateString"></span>
  <!-- <button class="btn btn-icon btn-light btn-due-date" [ngClass]="{'d-flex': dp.isOpen}" (click)="dp.show()" *ngIf="!dueDate"  [title]="'Set due date'">
    <span class="material-icons-outlined">
      edit
    </span>
  </button> -->
  <input class="due-date-picker"
    [(ngModel)]="selectedDate"
    #dp="bsDatepicker"
    bsDatepicker
    [bsConfig]="bsConfig"
    placement="bottom right"
    (bsValueChange)="onDueDateChange($event)">
</div>
